import type { FilterValue } from '../behandlingssteder/filters-helper';
import type { HNVelgBehandlingsstedFrontend } from '../types/Resources';

import type { FilterButtonProps } from '@helsenorge/designsystem-react/components/Filter';

export type FilterResources = NonNullable<FilterButtonProps['resources']>;

export const getFilterResources = (resources: HNVelgBehandlingsstedFrontend | null): FilterResources => ({
  filterButtonText: resources?.filterShow,
  resetButtonText: resources?.filterReset,
  showButtonText: resources?.filterResultsShow,
  filterOverviewTitle: resources?.filterTitle,
  searchClearButtonAriaLabel: resources?.filterReset,
  searchButtonAriaLabel: resources?.filterSearchText,
  activeFiltersListLabel: resources?.filterSelected,
});

export const sortFilterValues = (filterValues: Array<FilterValue>): Array<FilterValue> => {
  return filterValues.sort((fv1: FilterValue, fv2: FilterValue) => {
    return fv1.displayName && fv2.displayName ? fv1.displayName.localeCompare(fv2.displayName, 'nb') : 0;
  });
};
